import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_ALL_OVERVIEW_METRICS_QUERY_KEY } from "../types/CommonTypes";
import { GET_ALL_OVERVIEW_METRICS_RESPONSE } from "../types/ResponseTypes";

async function getAllOverviewMetrics(
  tenantId: string,
  hospitalId: string,
  queryString: string
): Promise<GET_ALL_OVERVIEW_METRICS_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/all-metrics?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });

  return data;
}

export default function useGetAllOverviewMetricsQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_ALL_OVERVIEW_METRICS_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getAllOverviewMetrics(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}
